import React, { useContext, useEffect } from 'react'
import CreateInvoice from '../Components/CreateInvoice'
import { Context } from '../Context/Context'

const Invoice = ({ UserInvoice,verified, NumberOfInvoices,contentRef }) => {
    const {
        createInvoice,
        viewInvoice,
        deleteInvoice,
        sideBar,
        loadingInvoice,
        fetchInvoices
    } = useContext(Context)

    useEffect(() => {
        if (createInvoice || viewInvoice || sideBar || deleteInvoice) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [createInvoice, viewInvoice, sideBar, deleteInvoice])

    return <CreateInvoice verified={verified} contentRef={contentRef} getInvoice={fetchInvoices} loadingInvoice={loadingInvoice} NumberOfInvoices={NumberOfInvoices} UserInvoice={UserInvoice} />
}

export default Invoice